import { initializeApp } from "firebase/app";
import {
  getAuth,
  connectAuthEmulator,
  GoogleAuthProvider,
  FacebookAuthProvider,
  OAuthProvider,
} from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { onAuthStateChanged, getIdTokenResult } from "firebase/auth";

const firebaseConfig = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY ||
    "AIzaSyCqkSaHzsGew4RVzHAkkGr9K53330x_ADk",
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ||
    "giftgaff-dev.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "giftgaff-dev",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    "giftgaff-dev.firebasestorage.app",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "763292922847",
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ||
    "1:763292922847:web:9b0aaa918b41cdde4fca6a",
  measurementId:
    import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-LLKQR67HRN",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
// Applies to SMS copy and reCAPTCHA UI (Firebase Auth docs).
if (typeof navigator !== "undefined" && navigator.language) {
  auth.languageCode = navigator.language;
}

export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");

// Social auth providers
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const appleProvider = new OAuthProvider("apple.com");

// Opt-in emulators; default is real Firebase (giftgaff-dev / env-configured project).
const useEmulators = import.meta.env.VITE_USE_EMULATORS === "true";

const emulatorHost =
  import.meta.env.VITE_FIREBASE_EMULATOR_HOST || window.location.hostname;

if (useEmulators) {
  console.log(`[firebase] Using Firebase emulators at ${emulatorHost}`);
  connectAuthEmulator(auth, `http://${emulatorHost}:9099`, {
    disableWarnings: true,
  });
  connectFirestoreEmulator(db, emulatorHost, 8080);
  connectStorageEmulator(storage, emulatorHost, 9199);
  connectFunctionsEmulator(functions, emulatorHost, 5001);
}

// SANITY CHECK
if (import.meta.env.MODE === "development") {
  onAuthStateChanged(auth, async (u) => {
    if (!u) {
      console.log("❌ No auth user signed in");
      return;
    }
    try {
      const { claims } = await getIdTokenResult(u);
      console.log("🧾 token aud:", claims.aud);
      console.log("🧾 token iss:", claims.iss);
      console.log("🧾 client projectId:", auth.app.options.projectId);
    } catch (e) {
      console.log("Failed to get token result:", e);
    }
  });
}
